import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import React from 'react';

const AsideContentRemittance = () => {
  return (
    <Box className="ss-flex ss-flex-col ss-items-center ss-gap-10 ss-py-14">
      <Text variant="h3" className="ss-text-white ss-max-w-[350px] ss-text-center">
        Remittance and Regulatory Infrastructure Simplified
      </Text>
      <Text variant="paragraphLarge" className="ss-text-white ss-text-center">
        Powerful and fully-compliant remittance infrastructure and licenses, tailored to your needs
      </Text>
    </Box>
  );
};

export default AsideContentRemittance;
